import { errorHandlerDefault } from "./../utils/handler.util";
import { App } from "vue";

export const setupGlobalError = (app: App): void => {
  app.config.errorHandler = (e) => errorHandlerDefault(e);
};
